import { Icon, Text, Tooltip } from "@amzn/storm-ui";
import { infoCircle } from "@amzn/storm-ui-icons";
import type { ReactElement } from "react";
import styled from "styled-components";

import { insightTypeLabelLookup } from "../../utils/generatedInsights.utils";

const StyledIcon = styled(Icon)`
    color: ${({ theme }) => theme.color.gray[500]};
`;

export const YourInsightsTypeTooltip = (): ReactElement => {
    return (
        <>
            <Tooltip
                position="top"
                message={
                    <>
                        <Text>
                            <strong>{insightTypeLabelLookup.PKG}</strong>:
                            Packaged insights created based on your inputs
                        </Text>
                        <Text>
                            <strong>{insightTypeLabelLookup.WB}</strong>: Decks
                            compiled based on user customization on workbench
                        </Text>
                    </>
                }
                trigger={<StyledIcon type={infoCircle} />}
            />
        </>
    );
};
